import { type SVGProps, type ForwardRefExoticComponent, type RefAttributes, type ReactNode, Fragment } from 'react';
import { forwardRef, createElement, Children } from 'react';
const defaultAttributes = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};
export type SVGAttributes = Partial<SVGProps<SVGSVGElement>>;
type ComponentAttributes = RefAttributes<SVGSVGElement> & SVGAttributes;
export interface LucideProps extends ComponentAttributes {
  size?: string | number;
  absoluteStrokeWidth?: boolean;
}
export type LucideIcon = ForwardRefExoticComponent<LucideProps>;
export const createIcon = (iconName: string, ...iconNode: ReactNode[]): LucideIcon => {
  const Component = forwardRef<SVGSVGElement, LucideProps>(({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = '',
    ...rest
  }, ref) => {
    const computedStrokeWidth = absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth;
    return createElement('svg', {
      ref,
      ...defaultAttributes,
      width: size,
      height: size,
      stroke: color,
      strokeWidth: computedStrokeWidth,
      className: className,
      ...rest
    }, Children.map(iconNode, (child, index) => <Fragment key={index}>{child}</Fragment>));
  });
  Component.displayName = `${iconName}`;
  return Component;
};